import {Inject, Injectable} from '@angular/core';
import {EntitiesChannel} from "../../../commons/angular/classes/entities-channel";
import {RecommendationProcessModel} from "../../models/recommendation.model";

@Injectable({providedIn: 'root'})
export class RecommendationProcessChannelService extends EntitiesChannel<RecommendationProcessModel> {

  constructor(@Inject('firebaseService') protected firebaseService) {
    super()
  }

  getChannelName(): String {
    return "processTracking_changed";
  }

  getPartialChannelName(): String {
    return "";
  }

  getCreateChannelName(): String {
    return "";
  }

}
